import './ImageDeletedMessage.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';

interface ImageDeletedMessageProps {
  onRefresh: () => void;
}

export const ImageDeletedMessage = observer((props: ImageDeletedMessageProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='image-deleted-ph'>
      <S_Card className='center'>
        <ColumnLayout size='md'>
          <h5>{t('this_image_has_been_removed_from_project')}</h5>
          <Button onClick={props.onRefresh}>{t('back_to_image_list')}</Button>
        </ColumnLayout>
      </S_Card>
    </div>
  );
});
